<template>
  <div v-if="chartShow">
    <PieChart class="max-width-450" :chart-data="chartPlayersData" />
  </div>
</template>

<script>
  import PieChart from '../charts/Pie.js'

  export default {
    components: { PieChart },
    props: ['data'],
    data() {
      return {
        chartShow: false,

        chartPlayersData: {
          labels: [],
          datasets: [
            {
              label: 'Player',
              data: [],
              backgroundColor: [
                'rgb(255, 99, 132)',
                'rgb(54, 162, 235)',
                'rgb(145, 99, 132)',
                'rgb(54, 162, 54)',
                'rgb(255, 205, 86)',
              ],
            },
          ],
        },
      }
    },
    methods: {
      async readPlayersChart() {
        let players = this.data.playersCount
        for (let index = 0; index < players.length; index++) {
          let player = players[index]
          this.chartPlayersData.labels.push(player._id)
          this.chartPlayersData.datasets[0].data.push(player.count)
        }
        this.chartShow = true
      },
    },
    mounted() {
      this.readPlayersChart()
    },
  }
</script>

<style scoped>
  .max-width-450 {
    max-width: 450px;
  }
</style>
